import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { IncomeConceptModel } from 'src/app/models/wallet/income-concept.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IncomeConceptService {

  constructor(private _httpClient: HttpClient) { }

  createIncomeConcept(incomeConceptModel: IncomeConceptModel): Observable<IncomeConceptModel> {
    return this._httpClient.post<IncomeConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.incomeConcept.CreateIncomeConcept}`,
      incomeConceptModel);
  }

  deleteIncomeConcept(incomeConceptId: number): Observable<IncomeConceptModel> {
    return this._httpClient.delete<IncomeConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.incomeConcept.DeleteIncomeConcept}/${incomeConceptId}`);
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.incomeConcept.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getAllIncomeConcept(): Observable<Array<IncomeConceptModel>> {
    return this._httpClient.get<Array<IncomeConceptModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.incomeConcept.GetAllIncomeConcept}`)
  }

  getAllIncomeConceptsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.incomeConcept.GetAllIncomeConceptsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.incomeConcept.GetColumnsForGeneralConsultationAsync}`);
  }

  getFirstIncomeConceptByKeys(branchId: number): Observable<IncomeConceptModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<IncomeConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.incomeConcept.GetFirstIncomeConceptByKeysAsync}`,
      { params: params }
    );
  }

  getIncomeConceptById(incomeConceptId: number): Observable<IncomeConceptModel> {
    return this._httpClient.get<IncomeConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.incomeConcept.GetIncomeConceptById}/${incomeConceptId}`)
  }

  getIncomeConceptByKeys(branchId: number, code: number): Observable<IncomeConceptModel> {
    return this._httpClient.get<IncomeConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.incomeConcept.GetIncomeConceptByKeys}/${branchId}/${code}`);
  }

  getIncomeConceptByBranchId(branchId: number): Observable<Array<IncomeConceptModel>> {
    return this._httpClient.get<Array<IncomeConceptModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.incomeConcept.GetIncomeConceptByBranchId}/${branchId}`)
  }

  getLastIncomeConceptByKeys(branchId: number): Observable<IncomeConceptModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<IncomeConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.incomeConcept.GetLastIncomeConceptByKeysAsync}`,
      { params: params }
    );
  }

  getNextIncomeConceptByKeys(branchId: number, code: number): Observable<IncomeConceptModel> {
    const params = new HttpParams().set('branchId', branchId).set('code', code);
    return this._httpClient.get<IncomeConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.incomeConcept.GetNextIncomeConceptByKeysAsync}`,
      { params: params }
    );
  }

  getPreviusIncomeConceptByKeys(branchId: number, code: number): Observable<IncomeConceptModel> {
    const params = new HttpParams().set('branchId', branchId).set('code', code);
    return this._httpClient.get<IncomeConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.incomeConcept.GetPreviusIncomeConceptByKeysAsync}`,
      { params: params }
    );
  }

  updateIncomeConcept(incomeConceptModel: IncomeConceptModel): Observable<IncomeConceptModel> {
    return this._httpClient.put<IncomeConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.incomeConcept.UpdateIncomeConcept}`,
      incomeConceptModel);
  }
}
